import { Injectable } from '@angular/core';
import { DeviceDetectorService } from 'ngx-device-detector';

@Injectable({
    providedIn: 'root'
})
export class LayoutSettingsService {
    private layout: any;

    constructor(private deviceDetectorService: DeviceDetectorService) {
        // Layout Settings
        // -----------------------------------
        this.layout = {
            isFixed: true,
            isCollapsed: false,
            isBoxed: false,
            isRTL: false,
            horizontal: false,
            isFloat: false,
            asideHover: false,
            theme: null,
            asideScrollbar: false,
            isCollapsedText: false,
            useFullLayout: false,
            hiddenFooter: false,
            asideToggled: false,
            viewAnimation: 'ng-fadeInUp'
        };

        if (this.deviceDetectorService.isTablet() && window.innerWidth > 767 && window.innerWidth < 992) {
            this.setLayoutSetting('isCollapsed', true);
        }
    }

    getLayoutSetting(name) {
        return name ? this.layout[name] : this.layout;
    }

    setLayoutSetting(name, value) {
        if (typeof this.layout[name] !== 'undefined') {
            return this.layout[name] = value;
        }
    }

    toggleLayoutSetting(name) {
        return this.setLayoutSetting(name, !this.getLayoutSetting(name));
    }

    resetLayoutSettings(): void {
        this.setLayoutSetting('isCollapsed', false);
        this.setLayoutSetting('asideToggled', false);
    }
}
